import { z } from 'zod';

/** Ответ POST/DELETE /events/:id/follow-next — текущее состояние подписки на орга. */
export const FollowNextResult = z.object({
  following: z.boolean(),
});
export type FollowNextResult = z.infer<typeof FollowNextResult>;
